import { DateTime } from 'luxon';

import { EventCalendarTableInstance } from './instance';
import { EventDateActions } from './rowActions';

export const EventDateColumns = [
  EventCalendarTableInstance.columnHelper.accessor('starting_at', {
    id: 'date',
    header: 'Date',
    cell: (props) =>
      DateTime.fromISO(props.row.original.starting_at).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    enableSorting: false,
  }),
  EventCalendarTableInstance.columnHelper.accessor('title', {
    header: 'Event Date Title',
    cell: (props) => props.row.original.title,
    enableSorting: false,
  }),
  EventCalendarTableInstance.columnHelper.accessor('starting_at', {
    header: 'Start Time',
    cell: (props) =>
      DateTime.fromISO(props.row.original.starting_at).toLocaleString(DateTime.TIME_SIMPLE),
    size: 100,
    enableSorting: false,
  }),
  EventCalendarTableInstance.columnHelper.accessor('ending_at', {
    header: 'End Time',
    cell: (props) =>
      DateTime.fromISO(props.row.original.ending_at).toLocaleString(DateTime.TIME_SIMPLE),
    size: 100,
    enableSorting: false,
  }),
  EventCalendarTableInstance.columnHelper.accessor('event_date_tickets', {
    header: 'Ticket Types',
    cell: (props) =>
      props.row.original.event_date_tickets?.map((ticket) => ticket.store_item.name).join(', '),
    enableSorting: false,
  }),
  EventCalendarTableInstance.columnHelper.display({
    id: 'actions',
    cell: (props) => <EventDateActions {...props} />,
    size: 40,
  }),
];
